import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import FaceOutlinedIcon from '@material-ui/icons/FaceOutlined';
import * as _ from 'lodash';
import clsx from 'clsx';
import Button from 'UI/button';
import CostPriceModal from './costPriceModal';
import SellPriceModal from './sellPriceModal';
import OfferModal from './offerModal';
import CruisePortalModal from './cruisePortalModal';
import HotelPortalModal from './hotelPortalModal';
import ItinerarySentModal from './itinerarySentModal';
import RequestQuotationModal from './requestQuotationModal';
import CheckAvailabilityModal from './checkAvailabilityModal';

class PricingPanel extends Component {
  constructor(props) {
    super(props);

    let { aiItineraryData } = props;
    if (_.isNil(aiItineraryData)) {
      aiItineraryData = {};
    }
  }

  formatPrice = (price) => {    
    return price ? `₹${price.toLocaleString('en-IN')}` : '';
  };

  render() {
    const {
      classes,
      expert,
      aiItineraryData,
      activeModal,
      selectedComponentId,
      closePricingModal,
      updateCostPrice,
      openPricingModal,
      updateItineraryData,
      showSnackbar,
      itineraryId,
      primaryButtonText,
      handlePrimaryButtonClick,
      chatLoading,
      requestUsId,
      handleGetPDF,
      handleGetLink,
    } = this.props;

    const {
      itineraryParts = [], costPrice, sellPrice, offer,
    } = aiItineraryData;

    const finalSellPrice = (offer?.offerAmount > 0) ? offer.finalSellPrice : sellPrice;
    const earnings = (sellPrice > 0 && costPrice > 0)
      ? _.floor(((finalSellPrice - costPrice) * (expert.commissionPercent || 0))/100)
      : null;

    return (
      <>
        <div className={classes.panel}>
          <div className={classes.body}>
            {/* Designer Information */}
            <div className={classes.designerSection}>
              {expert?.profilePicture ? (
                <img
                  src={expert.profilePicture}
                  alt="Designer"
                  className={classes.profileImage}
                />
              ) : (
                <FaceOutlinedIcon
                  className={classes.faceIcon}
                />
              )}
              <div className={classes.designerInfo}>
                <span className={classes.designedBy}>Designed by</span>
                <span className={classes.designerName}>{expert?.fullName || 'Shreya'}</span>
              </div>
            </div>

            {/* Cost Price */}
            <div className={classes.costPriceSection}>
              <div className={classes.costPriceRow}>
                {
                  costPrice > 0                   
                    ? (
                      sellPrice
                        ? (
                          <>
                            <span className={classes.sellPriceValue}>{this.formatPrice(finalSellPrice)}</span>                            
                          </>
                        )
                        : (
                          <>
                            <span className={classes.costPriceValue}>{this.formatPrice(costPrice)}</span>
                            <span className={classes.costPriceLabel}>Cost Price</span>
                          </>
                        )
                    ) 
                    : (
                      <span className={classes.costPriceMissing}>{itineraryParts.filter((ip) => !ip.costPrice && !ip.manualCostPrice && !ip.isFree).length} Component<br /> Price missing</span>
                    )
                }
              </div>
            </div>
            {
              !_.isNil(earnings) && (
                <div className={classes.earningsSection}>                  
                  <span className={classes.earningsValue}>{this.formatPrice(earnings)}</span> Earnings
                </div>
              )
            }

            {/* Action Buttons */}
            <Button
              variant="outlined"
              className={clsx(
                classes.editPricingButton,
                (costPrice && sellPrice) ? null : classes.hidden
              )}
              onClick={() => {
                openPricingModal('sell');
              }}
              disabled={chatLoading}
            >
              Edit Pricing
            </Button>

            <Button
              variant="outlined"
              className={clsx(
                classes.checkAvailabilityButton,
                (costPrice && sellPrice && aiItineraryData.itinerarySyncedAt) ? null : classes.hidden
              )}
              onClick={() => {
                openPricingModal('checkAvailability');
              }}
              disabled={chatLoading}
            >
              Check Availability
            </Button>
          </div>
          <button
            type="button"
            className={clsx(classes.primaryButton)}
            onClick={handlePrimaryButtonClick}   
            disabled={chatLoading}
          >
            {primaryButtonText.toUpperCase()}
          </button>
        </div>

        {/* Cost Price Modal */}
        <CostPriceModal
          isOpen={activeModal === 'cost'}
          closePricingModal={closePricingModal}
          openPricingModal={openPricingModal}
          expert={expert}
          updateCostPrice={updateCostPrice}
          requestUsId={requestUsId}
          aiItineraryData={aiItineraryData}
          updateItineraryData={updateItineraryData}
        />

        {/* Sell Price Modal */}
        <SellPriceModal
          isOpen={activeModal === 'sell'}
          closePricingModal={closePricingModal}
          openPricingModal={openPricingModal}
          aiItineraryData={aiItineraryData}
          updateItineraryData={updateItineraryData}
          showSnackbar={showSnackbar}
          itineraryId={itineraryId}
          itineraryParts={itineraryParts}
        />

        {/* Offer Modal */}
        <OfferModal
          isOpen={activeModal === 'offer'}
          closePricingModal={closePricingModal}
          aiItineraryData={aiItineraryData}
          updateItineraryData={updateItineraryData}
          showSnackbar={showSnackbar}
          openPricingModal={openPricingModal}
        />

        {/* Cruise Portal Modal */}
        <CruisePortalModal
          isOpen={activeModal === 'cruisePortal'}
          closePricingModal={closePricingModal}
          aiItineraryData={aiItineraryData}
          selectedComponent={selectedComponentId}
        />

        {/* Hotel Portal Modal */}
        <HotelPortalModal
          isOpen={activeModal === 'hotelPortal'}
          closePricingModal={closePricingModal}
          aiItineraryData={aiItineraryData}
          selectedComponent={selectedComponentId}
        />

        {/* Itinerary Sent Modal */}
        <ItinerarySentModal
          isOpen={activeModal === 'itinerarySent'}
          closePricingModal={closePricingModal}
          aiItineraryData={aiItineraryData}          
          itineraryId={itineraryId}
          showSnackbar={showSnackbar}
          updateItineraryData={updateItineraryData}
          openPricingModal={openPricingModal}
          handleGetPDF={handleGetPDF}
          handleGetLink={handleGetLink}
        />

        {/* Request Quotation Modal */}
        <RequestQuotationModal
          isOpen={activeModal === 'requestQuotation'}
          closePricingModal={closePricingModal}
          updateItineraryData={updateItineraryData}
          aiItineraryData={aiItineraryData}
          itineraryId={itineraryId}
          showSnackbar={showSnackbar}
        />

        {/* Check Availability Modal */}
        <CheckAvailabilityModal
          isOpen={activeModal === 'checkAvailability'}
          closePricingModal={closePricingModal}
          itineraryId={itineraryId}
          showSnackbar={showSnackbar}
        />
      </>
    );
  }
}

const styles = (theme) => ({
  panel: {
    position: 'absolute',
    top: 130, // Align with top of Trip Overview (same marginTop as TripOverview)
    right: 0, // 48px margin from right edge
    width: 200,
    background: '#FFFFFF',
    borderRadius: 12,
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    display: 'flex',
    flexDirection: 'column', 
    fontFamily: 'Sofia-pro, sans-serif',
  },
  body: {
    padding: 20,
  },
  designerSection: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 24,
  },
  profileImage: {
    width: 48,
    height: 48,
    borderRadius: 24,
    objectFit: 'cover',
    marginRight: 12,
  },
  designerInfo: {
    display: 'flex',
    flexDirection: 'column',
  },
  designedBy: {
    fontSize: 14,
    color: '#666666',
    marginBottom: 3,
    fontFamily: 'Sofia-pro, sans-serif',
  },
  designerName: {
    fontSize: 18,
    color: '#32302F',
    fontWeight: 700,
    fontFamily: 'Sofia-pro, sans-serif',
  },
  costPriceSection: {
    marginBottom: 12,
  },
  costPriceRow: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 3,
  },
  sellPriceValue: {
    fontSize: 24,
    color: '#0090B5',
    fontWeight: 700,
  },
  costPriceValue: {
    fontSize: 18,
    color: theme.colors.lightText,    
    marginRight: 6,
  },
  costPriceLabel: {
    fontSize: 14,
    color: theme.colors.lightText,
  },
  costPriceMissing: {
    fontSize: 14,
    color: theme.colors.red,
  },
  hidden: {
    display: 'none',
  },
  editPricingButton: {
    width: 120,
    height: 34,
    border: '1px solid #0090B5',
    borderRadius: 17,
    backgroundColor: 'transparent',
    fontSize: 16,
    fontWeight: 500,
    cursor: 'pointer',
    marginBottom: 12,
  },
  checkAvailabilityButton: {
    width: 160,
    height: 34,
    border: '1px solid #0090B5',
    borderRadius: 17,
    backgroundColor: 'transparent',
    fontSize: 16,
    fontWeight: 500,
    cursor: 'pointer',
    marginBottom: 12,
  },
  primaryButton: {
    width: '100%',
    height: 42,
    borderRadius: '0px 0px 10px 10px',    
    fontSize: 16,
    fontWeight: 500,
    textTransform: 'uppercase',
    marginTop: 'auto',
    background: '#0090B5',
    border: '1px solid #0090B5',
    color: '#FFFFFF',
    cursor: 'pointer',
  },
  primaryButtonDisabled: {
    background: '#DDDDDD',
    border: '1px solid #DDDDDD',
    color: '#666666',
    cursor: 'not-allowed',
  },
  primaryButtonEnabled: {
    background: '#0090B5',
    border: '1px solid #0090B5',
    color: '#FFFFFF',
    cursor: 'pointer',
  },
  faceIcon: {
    width: 36,
    height: 36,
    color: '#666666',
    marginRight: 8,
  },
  earningsSection: {
    marginBottom: 20,
    fontSize: 14,
  },
  earningsValue: {
    fontSize: 16,
    fontWeight: 400,
  },
});

PricingPanel.propTypes = {
  activeModal: PropTypes.oneOf(['cost', 'sell', 'offer', 'cruisePortal', 'hotelPortal', 'itinerarySent', 'requestQuotation', 'checkAvailability', null]),
  selectedComponentId: PropTypes.string,
  openPricingModal: PropTypes.func.isRequired,
  closePricingModal: PropTypes.func.isRequired,
  handlePrimaryButtonClick: PropTypes.func.isRequired,
  expert: PropTypes.object.isRequired,
  aiItineraryData: PropTypes.object.isRequired,
  updateItineraryData: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  showSnackbar: PropTypes.func,
  itineraryId: PropTypes.string,
  updateCostPrice: PropTypes.func.isRequired,
  primaryButtonText: PropTypes.string.isRequired,
  chatLoading: PropTypes.bool,
  requestUsId: PropTypes.string,
  handleGetPDF: PropTypes.func.isRequired,
  handleGetLink: PropTypes.func.isRequired,
};

export default withStyles(styles)(PricingPanel); 
